import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { Adg4Button } from "@/components/adg4/button/src";
import { Button } from "@/libraries/design/components";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { useAccountCreationContext } from "../../hooks";

export const Submit = ({ buttonText }: { buttonText?: string }) => {
    const intl = useIntl();

    const { isSubmitting, hasSubmitted, formError, onClickSubmitButton } =
        useAccountCreationContext();

    if (buttonText === undefined) {
        buttonText = intl.formatMessage({
            id: "BxpUiSignup.SignupForm.submit",
            defaultMessage: "Sign up"
        });
    }

    const modalVisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    if (modalVisualUpdates) {
        return (
            <Button
                css={buttonCss}
                type="submit"
                isDisabled={isSubmitting || (hasSubmitted && !formError)}
                isLoading={isSubmitting || (hasSubmitted && !formError)}
                onClick={onClickSubmitButton}
            >
                {buttonText}
            </Button>
        );
    }

    return (
        <Adg4Button
            type="submit"
            isDisabled={isSubmitting || (hasSubmitted && !formError)}
            isFullWidth={true}
            isLoading={isSubmitting || (hasSubmitted && !formError)}
            onClick={onClickSubmitButton}
        >
            {buttonText}
        </Adg4Button>
    );
};

const buttonCss = css({
    fontFamily: "inherit",
    fontSize: 16,
    maxWidth: "auto",
    paddingBlock: 8,
    width: "100%"
});
